import { ESubAgentsActionTypes, TSubAgentsPayload, TSubAgentsSearchPayload } from './types';
import { actionGenerator } from '../../utils/redux/actionGenerator';

/**
 * Запрос за списком сотрудников
 */
export const setSubAgentsPending = actionGenerator<ESubAgentsActionTypes.SetPending, void>(
  ESubAgentsActionTypes.SetPending,
);

/**
 * Установить список сотрудников
 */
export const setSubAgentsSucceed = actionGenerator<ESubAgentsActionTypes.SetSucceed, TSubAgentsPayload>(
  ESubAgentsActionTypes.SetSucceed,
);

/**
 * Установить ошибку запроса списка сотрудников
 */
export const setSubAgentsFailed = actionGenerator<ESubAgentsActionTypes.SetFailed, void>(
  ESubAgentsActionTypes.SetFailed,
);

/**
 * Установить значение поиска списка сотрудников
 */
export const setSubAgentsSearch = actionGenerator<ESubAgentsActionTypes.SetSearch, TSubAgentsSearchPayload>(
  ESubAgentsActionTypes.SetSearch,
);
